<section class="table_lis_data">
  <div id="header-detail" class="d-flex justify-content-end">
    <app-custom-button [title]="'Agregar Adjunto'" [label]="'Agregar Adjunto'" [icon]="'pi pi-paperclip'"
      [width]="'9rem'" (onClick)="attachFiles()"></app-custom-button>
    <input id="files" name="files" #files type="file" (change)="chooseFile($event)" hidden>
  </div>
  <div class="pt-1">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
      <app-custom-table [headers]="header" [data]="detailData" [actions]="tableActions"
        (onPageChange)="onPageChange($event)" (onRecoverData)="getAllInvoiceAttachments()"
        (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>